import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import {
	TextField,
	Typography,
	Grid,
	Button,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Card } from "reactstrap";
import { IoMdSend } from "react-icons/io";
import { useHistory } from "react-router-dom";
import { Alert } from "reactstrap";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import { IoMdSave } from "react-icons/io";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SaveIcon from "@mui/icons-material/Save";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AddLoadLimit = () => {
	const [customerId, setCustomerId] = useState("");
	const [currency, setCurrency] = useState("");
	const [level, setLevel] = useState("");
	const [dailyAmountLimit, setDailyAmountLimit] = useState("");
	const [weeklyAmountLimit, setWeeklyAmountLimit] = useState("");
	const [monthlyAmountLimit, setMonthlyAmountLimit] = useState("");
	const [yearlyAmountLimit, setYearlyAmountLimit] = useState("");
	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const [addOrUpdateLoadLimitStatus, setaddOrUpdateLoadLimitStatus] =
		useState(false);

	const [addOrUpdateLoadLimitResArray, setaddOrUpdateLoadLimitResArray] =
		useState("");

	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	// console.log("adminCurrencyList", adminCurrencyList);
	// console.log("adminCurrencyList", adminCurrencyList);

	const addOrUpdateLoadLimitRes = useSelector(
		({ addOrUpdateLoadLimit }) => addOrUpdateLoadLimit
	);

	// console.log("addOrUpdateLoadLimitRes", addOrUpdateLoadLimitRes);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "customerId") {
			setCustomerId(value);
		}

		if (name === "currency") {
			// setCurrency(value);
			setCurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "level") {
			// setLevel(value);
			setLevel(value == "Select Level" ? "" : value);
		}

		if (name === "DailyAmountLimit") {
			//  setDailyAmountLimit(value);
			Util.verifyAmount(value)
				? setDailyAmountLimit(value)
				: setDailyAmountLimit(dailyAmountLimit);
		}

		if (name === "WeeklyAmountLimit") {
			//  setWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setWeeklyAmountLimit(value)
				: setWeeklyAmountLimit(weeklyAmountLimit);
		}

		if (name === "MonthlyAmountLimit") {
			//  setMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setMonthlyAmountLimit(value)
				: setMonthlyAmountLimit(monthlyAmountLimit);
		}

		if (name === "YearlyAmountLimit") {
			//  setYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setYearlyAmountLimit(value)
				: setYearlyAmountLimit(yearlyAmountLimit);
		}
	};

	const addLoadLimitFunc = () => {
		setaddOrUpdateLoadLimitStatus(true);
		const addLoadLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: customerId,
				currency: currency,
				level: level,
				dailyLimit: dailyAmountLimit,
				weeklyLimit: weeklyAmountLimit,
				monthlyLimit: monthlyAmountLimit,
				yearlyLimit: yearlyAmountLimit,
				limitId: ""
			}
		};

		return dispatch(addOrUpdateLoadLimit(addLoadLimitReq, authToken));
	};

	useEffect(() => {
		if (addOrUpdateLoadLimitStatus) {
			addOrUpdateLoadLimitResFunc();
		}
	}, [addOrUpdateLoadLimitRes.data.status]);

	const addOrUpdateLoadLimitResFunc = () => {
		if (addOrUpdateLoadLimitStatus) {
			if (addOrUpdateLoadLimitRes.data.status == "success") {
				setNotificationOpen(true);
				setaddOrUpdateLoadLimitResArray(addOrUpdateLoadLimitRes.data);
			}
			if (
				addOrUpdateLoadLimitRes.data.status == "failed" ||
				addOrUpdateLoadLimitRes.data.status == "Failed"
			) {
				setNotificationOpen(true);
				setaddOrUpdateLoadLimitResArray(addOrUpdateLoadLimitRes.data);
				if (
					addOrUpdateLoadLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateLoadLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid container>
						<Grid item lg={2} md={2}></Grid>
						<Grid item lg={10} md={10}></Grid>
					</Grid>
					<Grid container>
						<Grid item lg={12} md={12} sm={12}>
							<h6 align="center" className="text-center themeText">
								Add Load Limit
							</h6>
						</Grid>
					</Grid>

					<Grid container style={{ padding: "10px" }}>
						<Grid item xs={12} md={2} lg={2}></Grid>

						<Grid item xs={12} md={8} lg={8}>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									autoFocus={true}
									type="text"
									variant="standard"
									label="Currency"
									fullWidth={true}
									name="currency"
									// value={currency || ""}
									defaultValue={"Select Currency" || currency}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Currency" selected="Select Currency">
										Select Currency
									</MenuItem>
									{adminCurrencyList.success &&
										[]
											.concat(adminCurrencyList.data.currencyList)
											.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
								</TextField>
							</div>
							{/* <div style={{ marginTop: "1.5rem" }}>
                <TextField
                  type="text"
                  size="small"
                  color="primary"
                  autoFocus={true}
                  label="Customer ID"
                  fullWidth={true}
                  name="customerId"
                  value={customerId || ""}
                  onChange={handleChange}
                />
              </div> */}
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									select
									size="small"
									color="primary"
									variant="standard"

									autoFocus={true}
									type="text"
									label="Level"
									fullWidth={true}
									name="level"
									// value={level || ""}
									defaultValue={"Select Level" || level}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								>
									<MenuItem value="Select Level" selected="Select Level">
										Select Level
									</MenuItem>
									<MenuItem value="BASIC">BASIC</MenuItem>
									<MenuItem value="STANDARD">STANDARD</MenuItem>
									<MenuItem value="PREMIUM">PREMIUM</MenuItem>
									<MenuItem value="SUPREME">SUPREME</MenuItem>
								</TextField>
							</div>
							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									color="primary"
									variant="standard"

									autoFocus={true}
									label="Daily Amount Limit"
									fullWidth={true}
									name="DailyAmountLimit"
									value={dailyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									variant="standard"

									color="primary"
									autoFocus={true}
									label="Weekly Amount Limit"
									fullWidth={true}
									name="WeeklyAmountLimit"
									value={weeklyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									variant="standard"

									color="primary"
									autoFocus={true}
									label="Monthly Amount Limit"
									fullWidth={true}
									name="MonthlyAmountLimit"
									value={monthlyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								></TextField>
							</div>

							<div style={{ marginTop: "1.5rem" }}>
								<TextField
									required
									type="text"
									size="small"
									variant="standard"

									color="primary"
									autoFocus={true}
									label="Yearly Amount Limit"
									fullWidth={true}
									name="YearlyAmountLimit"
									value={yearlyAmountLimit || ""}
									onChange={handleChange}
									InputProps={{
										sx: {
										  "&:before": { borderBottomColor: "gray" }, // before focus
										  "&:after": { borderBottomColor: "gray" },  // after focus
										},
									  }}
									  InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									  }}
								/>
							</div>

							<div className="text-center" style={{ marginTop: "2.5rem" }}>
								{/* <Button
									style={{
										// marginLeft: "0.7rem",
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									// color="primary"
									onClick={addLoadLimitFunc}
									endIcon={<SaveIcon />}
								>
									Save
								</Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={addLoadLimitFunc}
									endIcon={<SaveIcon />}
								>
									Save <SaveIcon />
								</CustomButton>
							</div>
						</Grid>

						<Grid item xs={12} md={2} lg={2}></Grid>
					</Grid>
				</Card>
			</Layout>

			{addOrUpdateLoadLimitResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateLoadLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateLoadLimitResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateLoadLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateLoadLimitResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateLoadLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AddLoadLimit;
